import { Login, LoginForm } from 'react-admin';

const LoginPage = () => (
  <Login backgroundImage="/background.jpg">
    <img src="/bnp.svg" alt="Logo BNP" style={{ margin: "10px 50px"}} />
    <LoginForm />
  </Login>
);

export default LoginPage;